// Aquí está el slice de usuario
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  infoActivarEmpresa: null,
  failureActivarEmpresa: false,
  isLoadingActivarEmpresa: false,
  errorActivarEmpresa: null,
};

const activarEmpresaSlice = createSlice({
  name: "activarEmpresa",
  initialState,
  reducers: {
    activarEmpresaSuccess: (state, action) => {
      state.infoActivarEmpresa = action.payload.info;
      state.failureActivarEmpresa = false;
      state.isLoadingActivarEmpresa = false;
    },
    activarEmpresaFailure: (state, action) => {
      state.failureActivarEmpresa = true;
      state.isLoadingActivarEmpresa = false;
      state.errorActivarEmpresa = action.payload; // mensaje de errorActivarEmpresa
    },
    activarEmpresaReset: (state) => {
      state.infoActivarEmpresa = null;
      state.failureActivarEmpresa = false;
      state.errorActivarEmpresa = null;
      state.isLoadingActivarEmpresa = false;
    },
    setInfoEmpresa: (state, action) => {
      state.infoActivarEmpresa = action.payload;
    }
  },
});


export const {
  activarEmpresaSuccess,
  activarEmpresaFailure,
  activarEmpresaReset,
  setInfoEmpresa,
} = activarEmpresaSlice.actions;
export default activarEmpresaSlice.reducer;
